<template>
  <v-tooltip v-if="organisation.latestLicenceValidOnYear" bottom>
    <template #activator="{ on, attrs }">
      <AppChip
        :color="chipColor"
        v-bind="attrs"
        text-color="white--text"
        data-test="licenceStatusBadge"
        v-on="on"
        >{{ organisation.latestLicenceValidOnYear }}</AppChip
      >
    </template>
    <span>{{
      $t(
        "organisations:membership.licence.lastIssuedLicence.tooltip",
        "Last issued licence"
      )
    }}</span>
  </v-tooltip>
</template>
<script>
import { defineComponent, computed } from "vue";
import gql from "fraql";
import AppChip from "@elements/AppChip.vue";

export default defineComponent({
  name: "AppShowOrganisationLicenceBadge",
  components: { AppChip },
  props: {
    organisation: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const chipColor = computed(() => {
      if (props.organisation.licenceValidCurrently) {
        return "green";
      }
      return "muted";
    });

    return { chipColor };
  },
  fragments: {
    organisationFields: gql`
      fragment _ on Organisation {
        latestLicenceValidOnYear
        licenceValidCurrently
      }
    `
  }
});
</script>
